import React from 'react';
import { NumericalColumn, StringColumn, CustomColumn } from 'baseui/data-table';
import dayjs from 'dayjs';
import { EMPTY_STRING, EMPTY_NUMBER } from 'commons-ui';

export const COL_NAMES = {
	orderId: 'orderId',
	createdAt: 'timestamp',
	amount: 'amount',
	zupeeTxnStatus: 'zupeeTxnStatus',
	merchant: 'merchant',
	paymentGateway: 'paymentGateway',
	pgTxnStatus: 'pgTxnStatus',
	pgReason: 'pgReason',
	name: 'name'
};

export const columnConfigs = [
	StringColumn({
		title: 'Order Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.orderId] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Amount (₹)',
		minWidth: 70,
		maxWidth: 70,
		mapDataToValue: (data: any) => data[COL_NAMES.amount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Merchant',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.name] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Zupee Status',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.zupeeTxnStatus] || EMPTY_STRING
	}),
	StringColumn({
		title: 'PG Status',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.pgTxnStatus] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Payment Gateway',
		minWidth: 100,
		maxWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.paymentGateway] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'PG Reason',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.pgReason] || EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let compressPgReason = '';
			if (value.length > 30) {
				compressPgReason = `${value.substr(0, 30)}...`;
			} else {
				compressPgReason = value;
			}
			return <div title={value}>{compressPgReason}</div>;
		}
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.createdAt] ? dayjs(new Date(data[COL_NAMES.createdAt])).format('YYYY-MM-DD hh:mm A') : EMPTY_STRING
	})
];
